import React from 'react';
import {Github} from 'lucide-react';
import {FaBars, FaTimes} from 'react-icons/fa';
import {translations} from '../translations';

const Header = ({language, isMenuOpen, toggleMenu}) => {
    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            window.scrollTo({
                top: element.offsetTop - 70,
                behavior: 'smooth'
            });
            if (isMenuOpen) toggleMenu();
        }
    };

    return (
        <nav>
            <div className="logo">
                <img src="/assets/images/logo.png" alt="OpenWES Logo"/>
                <h1 className="chinese-font">{translations[language]['nav.logo']}</h1>
            </div>
            <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
                <li><a href="#features" onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('features');
                }}>{translations[language]['nav.features']}</a></li>
                <li><a href="#solutions" onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('solutions');
                }}>{translations[language]['nav.solutions']}</a></li>
                <li><a href="#pricing" onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('pricing');
                }}>{translations[language]['nav.pricing']}</a></li>
                <li><a href="https://docs.openwes.top/" rel="noreferrer" target="_blank">{translations[language]['nav.resources']}</a></li>
                <li><a href="#contact" onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('contact');
                }}>{translations[language]['nav.contact']}</a></li>
                <li><a
                    href="https://github.com/jingsewu/open-wes"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-gray-900 text-white p-2 rounded-md hover:bg-gray-700 transition-colors flex items-center"
                >
                    <Github className="h-5 w-5"/>
                </a></li>
            </ul>
            <div className="mobile-menu" onClick={toggleMenu}>
                {isMenuOpen ? <FaTimes/> : <FaBars/>}
            </div>
        </nav>
    );
};

export default Header;
